// @ts-ignore
import * as React from "react";
import { Button, ButtonUse, ButtonSize } from "react-ui";

import { SEND_ACTION_BUTTON_CLICK } from "../../metricsAction";
import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";

export interface SendActionButtonProps {
    disabled?: boolean;
    use?: ButtonUse;
    size?: ButtonSize;
    place?: "embeddedLog" | "menu";
    text?: string;
    width?: number;
    onSendForm: () => Promise<void>;
    localValidationBeforeSend: () => Promise<boolean>;
    validationBeforeSend?: boolean;
}

export function SendActionButton(props: SendActionButtonProps): JSX.Element {
    const track = useMetrics();
    const { disabled, width, use, text, place, size = "medium" } = props;

    const handleToSend = async (): Promise<void> => {
        if (props.validationBeforeSend) {
            const isInvalid = await props.localValidationBeforeSend();
            if (isInvalid) {
                track(SEND_ACTION_BUTTON_CLICK, { place: place, invalidForm: true });
                return;
            }
        }
        track(SEND_ACTION_BUTTON_CLICK, { place: place });
        await props.onSendForm();
    };

    return (
        <TestPageObjectHandle
            id="SaveButton"
            pageObject={{
                getType: () => "SendActionButton",
                isDisabled: () => disabled ?? false,
            }}>
            <Button
                disabled={disabled}
                size={size}
                width={width}
                use={use ?? "primary"}
                onClick={handleToSend}
                data-tid={`SendButton`}>
                {text ?? "Перейти к отправке"}
            </Button>
        </TestPageObjectHandle>
    );
}
